import { useMemo } from 'react';
import { useRouter } from 'next/router';
import {
  getQuizDetails,
  getAllSectionalAnswers,
  getmaxAnswerableQuestion
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const useMaxAttemptQuestions = (sectionUID) => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  const sectionalAnswers = useSelectorWithShallowEqual(
    getAllSectionalAnswers(sectionUID)
  );
  const maxAnswerableQuestion = useSelectorWithShallowEqual(
    getmaxAnswerableQuestion(sectionUID)
  );

  const currentSection = useMemo(
    () => quizDetails?.sections?.find(({ uid }) => uid === sectionUID),
    [quizDetails?.sections, sectionUID]
  );

  const isMaxQuestionAttemptEnabled =
    maxAnswerableQuestion < currentSection?.questions_count;
  const totalQuestionAnswered = Object.keys(sectionalAnswers).length;
  const isQuestionAttemptable = totalQuestionAnswered < maxAnswerableQuestion;

  return {
    isMaxQuestionAttemptEnabled,
    totalQuestionAnswered,
    isQuestionAttemptable,
    maxAnswerableQuestion
  };
};

export default useMaxAttemptQuestions;
